const screenSizes = {
  small: {
    min: '0',
    max: '767px'
  },
  medium: {
    min: '768px',
    max: '969px'
  },
  large: {
    min: '970px',
    max: '1169px'
  },
  xlarge: {
    min: '1170px'
  }
};
const upQuery = min => `(min-width: ${min})`;
const onlyQuery = (min, max) => `(min-width: ${min}) and (max-width: ${max})`;
const downQuery = max => `(max-width: ${max})`;
const small = {
  only: downQuery(screenSizes.small.max)
};
const medium = {
  /** @deprecated use `breakpoints` from `@etg/wings` instead.
   *
   * ```@media (min-width: ${breakpoints._768}) {…}```  */
  up: upQuery(screenSizes.medium.min),
  only: onlyQuery(screenSizes.medium.min, screenSizes.medium.max),
  down: downQuery(screenSizes.medium.max)
};
const large = {
  /** @deprecated use `breakpoints` from `@etg/wings` instead.
   *
   * ```@media (min-width: ${breakpoints._970}) {…}```  */
  up: upQuery(screenSizes.large.min),
  only: onlyQuery(screenSizes.large.min, screenSizes.large.max),
  down: downQuery(screenSizes.large.max)
};
const xlarge = {
  only: upQuery(screenSizes.xlarge.min),
  /** @deprecated use `breakpoints` from `@etg/wings` instead.
   *
   * ```@media (min-width: ${breakpoints._1170}) {…}```  */
  up: upQuery(screenSizes.xlarge.min)
};

/**
 * @deprecated Do _NOT_ use `mediaQueries`, prefer the `breakpoints` export from `@etg/wings` instead.
 *
 * ```
 * import { breakpoints } from '@etg/wings';
 *
 * const style = css`
 *   …
 *
 *   @media (min-width: ${breakpoints._768}) {
 *     …
 *   }
 * `;
 * ```
 */
export default {
  small,
  medium,
  large,
  xlarge
};
//# sourceMappingURL=mediaQueries.js.map